import { Module } from 'vuex';

import { SearchState } from '../../models';

import { BrowseAction } from './actions/browse.action';
import { LoadAttributesAction } from './actions/load-attributes.action';
import { SearchAction } from './actions/search.action';
import { AttributesGetter } from './getters/attributes.getter';
import { SetAttributesMutation } from './mutations/set-attributes.mutation';
import { SEARCH_CONSTS } from './search.consts';

export const SEARCH_MODULE: Module<SearchState, any> = {
  namespaced: true,

  state: (): SearchState => {
    return {
      data: {
        attributes: {}
      }
    };
  },

  getters: {
    [SEARCH_CONSTS.getters.attributes]: AttributesGetter.execute
  },

  actions: {
    [SEARCH_CONSTS.actions.search]: SearchAction.execute,
    [SEARCH_CONSTS.actions.browse]: BrowseAction.execute,
    [SEARCH_CONSTS.actions.loadAttributes]: LoadAttributesAction.execute
  },

  mutations: {
    [SEARCH_CONSTS.mutations.setAttributes]: SetAttributesMutation.execute
  }

};
